export default __webpack_public_path__ + "static/media/youtubeCompany.e04db582.svg";